export default __webpack_public_path__ + "static/media/29-Brain-NEW.95050cba.svg";